import { useEffect }    from "react";
import { usePxoPage }   from "../../contexts/PxoPageContext";
import api              from "../../services/api";
import '../../styles/main.css';

export default function PxoHorizonFilter () {

    const { setHorizonTypes, handleSelectedHorizonTypeId, horizonTypes, selectedHorizonTypeId } = usePxoPage()

    const fetchHorizonTypes = async () => {
        
        try {
            
            const response = await api.get('/getAllPxoHorizons')
            setHorizonTypes(response.data)

        } catch (error) {

            console.error('Erro ao buscar tipos de horizonte:', error)
        
        }
        
    }

    useEffect(() => {
        fetchHorizonTypes()
    }, [])


    useEffect(() => {
        
        if (horizonTypes.length > 0) {

            handleSelectedHorizonTypeId(horizonTypes[0].id)
        }
    }, [horizonTypes])

    return(

        <section className="w-full bg-neutro borda-cinza rounded-[7px] p-4 flex justify-between gap-[10px] my-4 mx-auto">

            {horizonTypes.map((horizonType, index) => (
                <button 
                    
                    key={index}
                    data-index={index}
                    className={
                            
                        `w-full [transition:0.3s_ease] text-[0.8rem] outline-[none] border-[none] p-[4px] rounded-[4px] cursor-pointer font-saira  
                        ${selectedHorizonTypeId === horizonType.id ? 'bg-azul-profundo-m text-white' : 'bg-white text-black hover:bg-azul-profundo-c hover:text-white'}
                        hover:bg-azul-profundo-c hover:text-white z-10 h-10 w-[215px] `

                    }
                    onClick={() => {handleSelectedHorizonTypeId(horizonType.id)}}
                >
                    {horizonType.ownerHorizonOfPlan.name}
                </button>
            ))}
        
        </section>
    )

}